'use client'

import { IconCustomGoldPremium } from 'components/icons'
import { DuoCompass1, DuoLayout4Blocks } from 'components/icons/duotone'
import Link from 'components/shared/link'
import Logo from 'layout/Images/Logo'
import RightNavbar from '../RightNav/RightNavbar'
import { useConfig } from 'components/providers/ConfigProvider'
import { useTranslation } from 'components/providers/TranslationProvider'
import { ClientOnly } from 'app/components/client-only'

const PagesHeader = () => {
    const config = useConfig()
    const { t } = useTranslation()

    return (
        <div className='flex-col flex h-16 w-full'>
            <div className='flex h-16 items-center lg:left-[280px] justify-between z-50 !bg-background fixed lg:pl-6 inset-0 w-full lg:w-[calc(100%-280px)] md:pl-2 pl-4 pr-2 md:pr-4 navbar_glassmorphism'>
                <div className='flex items-center'>
                    <div className='flex items-center'>
                        <ClientOnly>
                            {config && <Logo config={config} className='lg:hidden' />}
                        </ClientOnly>

                        <nav className='hidden lg:flex items-center space-x-2.5'>
                            <Link
                                href='/home'
                                className='px-3 py-2 rounded-lg hover:font-bold items-center md:gap-1 lg:gap-2 flex text-sm font-light glassmorphism_hover hover:bg-muted cursor-pointer !transition-all !duration-700 whitespace-nowrap group'
                            >
                                <DuoLayout4Blocks className='h-full size-7' />
                                <span>{t?.('playerHub') ?? 'Player Hub'}</span>
                            </Link>
                            <Link
                                href='/explore/federations'
                                className='px-3 py-2 rounded-lg hover:font-bold items-center md:gap-1 lg:gap-2 flex text-sm font-light glassmorphism_hover hover:bg-muted cursor-pointer !transition-all !duration-700 whitespace-nowrap group'
                            >
                                <DuoCompass1 className='h-full size-6' />
                                <span>{t?.('explore') ?? 'Explore'}</span>
                            </Link>
                            <Link
                                href='/premium'
                                className='relative px-4 py-3 rounded-xl items-center md:gap-1 lg:gap-2 flex text-sm font-medium cursor-pointer transition-all duration-700 whitespace-nowrap group'
                            >
                                <IconCustomGoldPremium />
                                <span className='bg-gradient-to-r from-yellow-400 via-yellow-500 to-amber-600 bg-clip-text text-transparent font-semibold tracking-wide'>
                                    {t?.('premium') ?? 'Premium'}</span>
                            </Link>
                        </nav>
                    </div>
                </div>
                <div className='flex items-center justify-end shrink-0'>
                    <RightNavbar />
                </div>
            </div>
        </div>
    )
}

export default PagesHeader
